import { useTranslation } from "react-i18next"
import { CalendarCheck, CalendarX, MagnifyingGlass, PencilSimple, TrashSimple } from "@phosphor-icons/react"
import { DropdownMenuCheckboxItem } from "@/components/ui/dropdown-menu"

type AppointmentActionItemProps = {
  onClick: React.MouseEventHandler<HTMLDivElement>
}

export const EditAppointmentActionItem = ({ onClick }: AppointmentActionItemProps) => {
  const { t } = useTranslation()

  return (
    <DropdownMenuCheckboxItem className="text-on-surface" data-testid="agenda-edit-option" onClick={onClick}>
      <PencilSimple className="mr-3" /> {t("patient.agenda.grid.options.edit")}
    </DropdownMenuCheckboxItem>
  )
}

export const OpenDrawerAppointmentActionItem = ({ onClick }: AppointmentActionItemProps) => {
  const { t } = useTranslation()

  return (
    <DropdownMenuCheckboxItem className="text-on-surface" data-testid="agenda-openDrawer-option" onClick={onClick}>
      <MagnifyingGlass className="mr-3" /> {t("patient.agenda.grid.options.openDrawer")}
    </DropdownMenuCheckboxItem>
  )
}

export const CancelTeleconsultationAppointmentActionItem = ({ onClick }: AppointmentActionItemProps) => {
  const { t } = useTranslation()

  return (
    <DropdownMenuCheckboxItem
      className="text-on-surface"
      data-testid="agenda-cancel-teleconsultation"
      onClick={onClick}>
      <CalendarX className="mr-3" /> {t("patient.agenda.grid.options.cancelTeleconsultation")}
    </DropdownMenuCheckboxItem>
  )
}

export const DeleteTeleconsultationAppointmentActionItem = ({ onClick }: AppointmentActionItemProps) => {
  const { t } = useTranslation()

  return (
    <DropdownMenuCheckboxItem
      className="text-on-surface"
      data-testid="agenda-delete-teleconsultation"
      onClick={onClick}>
      <TrashSimple className="mr-3" /> {t("patient.agenda.grid.options.deleteTeleconsultation")}
    </DropdownMenuCheckboxItem>
  )
}

export const TakeConsultationAppointmentActionItem = ({ onClick }: AppointmentActionItemProps) => {
  const { t } = useTranslation()

  return (
    <DropdownMenuCheckboxItem
      className="text-on-surface"
      data-testid="take-teleconsultation"
      data-faro-user-action-name="waiting_room_consultation_take"
      onClick={onClick}>
      <CalendarCheck className="mr-3" /> {t("patient.agenda.grid.options.takeConsultation")}
    </DropdownMenuCheckboxItem>
  )
}

export const EditBillingInformationActionItem = ({ onClick }: AppointmentActionItemProps) => {
  const { t } = useTranslation()

  return (
    <DropdownMenuCheckboxItem
      className="text-on-surface"
      data-testid="agenda-editBillingInformation-option"
      onClick={onClick}>
      <PencilSimple className="mr-3" /> {t("patient.agenda.grid.options.editBillingInformation")}
    </DropdownMenuCheckboxItem>
  )
}

export const ShowBillingInformationActionItem = ({ onClick }: AppointmentActionItemProps) => {
  const { t } = useTranslation()

  return (
    <DropdownMenuCheckboxItem
      className="text-on-surface"
      data-testid="agenda-showBillingInformation-option"
      onClick={onClick}>
      <MagnifyingGlass className="mr-3" /> {t("patient.agenda.grid.options.showBillingInformation")}
    </DropdownMenuCheckboxItem>
  )
}
